module.exports = __webpack_public_path__ + "static/media/profile-pic.52f351d6.jpg";